/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_PlaceholderInputs */

const en_us2_coach_placeholder = /** @type {(inputs: Coach_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask your trainer`)
};

const pt_br2_coach_placeholder = /** @type {(inputs: Coach_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergunte ao seu personal`)
};

const es_419_coach_placeholder = /** @type {(inputs: Coach_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregúntale a tu entrenador`)
};

const pt_pt2_coach_placeholder = /** @type {(inputs: Coach_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergunta ao teu treinador`)
};

const fr_fr2_coach_placeholder = /** @type {(inputs: Coach_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demande à ton coach`)
};

const de_de2_coach_placeholder = /** @type {(inputs: Coach_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frag deinen Coach`)
};

const it_it2_coach_placeholder = /** @type {(inputs: Coach_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi al tuo coach`)
};

/**
* | output |
* | --- |
* | "Ask your trainer" |
*
* @param {Coach_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_placeholder = /** @type {((inputs?: Coach_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_placeholder(inputs)
	if (locale === "es-419") return es_419_coach_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_placeholder(inputs)
	if (locale === "de-DE") return de_de2_coach_placeholder(inputs)
	if (locale === "it-IT") return it_it2_coach_placeholder(inputs)
	return en_us2_coach_placeholder(inputs)
});
export { coach_placeholder as "coach.placeholder" }